<script>
import formInput from "@/mixins/shared/formInput";
import date from "@/mixins/shared/date";
import {TimePlugin} from '@easepick/time-plugin';

export default {
    mixins: [formInput, date],
    props: {
        'groupClasses': {
            type: String,
            required: false
        },
        'label': {
            type: String,
            required: false
        }
    },
    methods: {
        initialiseEasepick() {
            this.createEasepick({
                plugins: [TimePlugin],
                autoApply: false,
                // Easepick schrijft de waarde met dit formaat rechtstreeks in het element,
                // en <input type="datetime-local"> accepteert alleen deze notatie. Bij een
                // ander formaat verwerpt de browser de waarde en wordt het veld leeg, buiten
                // Vue om — het model blijft dan wél gevuld, dus dat valt niet op tot een
                // veld niet opnieuw gerenderd wordt.
                format: 'YYYY-MM-DDTHH:mm',
                TimePlugin: {
                    format: 'HH:mm',
                },
            });
            
            if (this.modelValue) {
                this.setPickerDate(this.modelValue);
            }
            
            this.$watch('modelValue', (value) => this.setPickerDate(value));
            
            this.enableApplyButtonOnTimeChange();
        },
        
        enableApplyButtonOnTimeChange() {
            const shadowRoot = this.datepicker?.Calendar?.picker?.ui?.shadowRoot;
            if (!shadowRoot) return;
            
            $(shadowRoot.firstChild).on('change', '.time-plugin-custom-input', (event) => {
                $(event.currentTarget)
                    .closest('.container')
                    .find('.apply-button')
                    .removeAttr('disabled');
            });
        }
    },
    mounted() {
        this.initialiseEasepick();
    }
}
</script>

<template>
	<div class="input-group">
		<template v-if="$slots.addonbefore">
			<span class="input-group-text">
				<slot name="addonbefore"/>
			</span>
		</template>
		<div class="dateinput-wrapper flex-grow-1">
			<input
				ref="input"
				:name="name"
				v-bind="$attrs"
				type="datetime-local"
				:value="modelValue"
				@change="changeDateByKeyboard"
				:id="renderedId"
                :class="{'form-control': true, 'border-danger': hasError, 'rounded-start-0' : $slots.addonbefore, 'rounded-end-0' : $slots.addonafter}"
            >
		</div>
		<span class="input-group-text" v-if="$slots.addonafter">
			<slot name="addonafter"/>
		</span>
		<span class="input-group-text" v-if="!$slots.addonafter">
			<i role="button" class="bi bi-calendar"  @click="this.$refs.input.click()"></i>
		</span>
	</div>
	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom"/>
	</div>
    <label v-if="hasError" class="text-danger mt-2 small">
        {{ this.form.errors[this.name] }}
    </label>
</template>